import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
//import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
//import { Keepalive } from '@ng-idle/keepalive';
import { ApiauthService } from 'src/app/services/apiauth.service';
//import { PushNotificationService } from './services/push-notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'app';

  idleState = 'Not started.';
  timedOut = false;
  lastPing : Date;


  constructor(
    public router: Router,
   // private idle: Idle,
  //  private keepalive: Keepalive,
    public apiauth: ApiauthService
  ) //  private notification: PushNotificationService
  {
    this.lastPing=new Date();
    //   notification.requestPermission().then((token) => {
    //     console.log(token);
    //   });

    // sets an idle timeout, prier timer
  //  idle.setIdle(840000);//14 munutos
    // sets a timeout period  despues de este tiempo mas el de iddle, el usuario pasa a estado timeout
  //  idle.setTimeout(60000);// 1 minuto

  //  idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

  /*   idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      console.log(this.idleState);
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      console.log(this.idleState);
      this.apiauth.logout();
      this.router.navigate(['/']);
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = "You've gone idle!";
      console.log(this.idleState);
    //  this.childModal.show();
    });

    idle.onTimeoutWarning.subscribe((countdown:any) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
      console.log(this.idleState);
    });
 */
    // sets the ping interval to 15 seconds
   // keepalive.interval(15);

  //  keepalive.onPing.subscribe(() => (this.lastPing = new Date()));


    this.apiauth.getUserLoggedIn().subscribe(userLoggedIn => {

//console.log("VALIDA USUARIO LOGUEADO: ",userLoggedIn);

    /*   if (userLoggedIn) {
        idle.watch()
        this.timedOut = false;
      } else {
        idle.stop();
      } */
    })

   // this.reset();
  }

  reset() {
  //  this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  ngOnInit(): void {
    // this.notification.receiveMessage().subscribe(payload=>{
    //   console.log(payload);
    // })
  }
}
